<template>
  <div class="page-main bg-w mt-20 ">
    <!-- <div class="fs-24 pd-20">{{ this.$store.state.user.isAdmin?'企业管理':'' }}</div> -->
    <a-menu v-model="current" mode="horizontal">
      <a-menu-item v-for="i in menuList" :key="i.path" @click="$router.push(i.path)"> {{ i.title }} </a-menu-item>
    </a-menu>
    <div class="pd-20">
      <router-view />
    </div>
  </div>
</template>
<script>

export default {
  data() {
    return {
      current: '',
      menuList: [
        {
          path: '/main/manager/personal-info-management',
          title: '个人信息管理'
        }
      ],
      adminList: [
        {
          path: '/main/manager/order',
          title: '账户管理'
        },
        {
          path: '/main/manager/settlement-settings',
          title: '快递结算设置'
        },
        {
          path: '/main/manager/employee-management',
          title: '部门员工管理'
        },
        {
          path: '/main/manager/company-info-management',
          title: '公司信息管理'
        }
      ],
      personalList: [
        {
          path: '/main/manager/company-info-management',
          title: '公司信息管理'
        }
      ]
    }
  },
  watch: {
    '$store.state.user.hasCompany': function(val) {
      if (!val) {
        this.menuList = this.personalList
      } else {
        this.menuList = [
          {
            path: '/main/manager/personal-info-management',
            title: '个人信息管理'
          }
        ]
        if (this.$store.state.user.isAdmin) {
          this.menuList = this.adminList.concat(this.menuList)
        }
      }
    }
  },
  created() {
    this.current = [this.$route.path]
    if (!this.$store.state.user.hasCompany) {
      this.menuList = this.personalList
      return false
    }
    if (this.$store.state.user.isAdmin) {
      this.menuList = this.adminList.concat(this.menuList)
    }
  },
  methods: {

  }
}
</script>
